// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5942":"7f240c6d","9242":"951eed68"}[chunkId] + ".chunk.css";
};